/*
 * Copyright Mission 42 Ventures, Inc. All rights reserved.
 * Unauthorized copying, distribution, or use is prohibited.
 */

import React from 'react';
import { SidebarItem } from '@backstage/core-components';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
import { useEnvDriftAccess } from '../envDrift/useEnvDriftApi';

/**
 * Sidebar entry for the Env Drift board (PLAT-1374). Reads are open to any
 * authenticated user, so the probe only hides the item while signed out (or
 * when the backend plugin is unavailable) -- same contract as
 * NetworkPolicySidebarItem.
 */
export const EnvDriftSidebarItem = () => {
  const { allowed } = useEnvDriftAccess();
  if (!allowed) return null;
  return <SidebarItem icon={CompareArrowsIcon} to="/env-drift" text="Env Drift" />;
};
